"use client";

import Link from "@/components/Link";
import { sendGtagEvent } from "@/lib/client/gtag";
import { getPopularModelsForBrand, getDefaultPopularModels } from "@/lib/shared/brandPopularModels";
import { generateBrandSlug } from "@/lib/shared/utils";

import styles from "./styles.module.scss";
import { Box as MantineBox, Text as MantineText, Title as MantineTitle } from "@mantine/core";

interface PopularModelsProps {
  brand?: BrandFilter;
  activeCategory?: string;
}

const PopularModels = ({ brand, activeCategory }: PopularModelsProps) => {
  const modelValues = brand?.id
    ? getPopularModelsForBrand(brand.id) || []
    : getDefaultPopularModels();

  if (!modelValues.length) return null;

  const formatSearchLink = (modelValue: string) => {
    if (brand) {
      const isActive = activeCategory
        ? modelValue.toLowerCase() === activeCategory.toLowerCase()
        : false;

      if (isActive) {
        return `/brands/${generateBrandSlug(brand.label)}`;
      }
      return `/brands/${generateBrandSlug(brand.label)}/${encodeURIComponent(modelValue)}`;
    }
    return `/search?searchText=${encodeURIComponent(modelValue)}`;
  };

  const formatDisplayLabel = (value: string) => {
    return value
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <MantineBox className={styles.popularModels}>
      <MantineTitle order={3}>Popular Models</MantineTitle>
      <MantineBox className={styles.modelsContainer}>
        {modelValues.map((modelValue) => {
          const isActive = activeCategory
            ? modelValue.toLowerCase() === activeCategory.toLowerCase()
            : false;

          return (
            <Link
              key={modelValue}
              aria-label={`search for ${modelValue}`}
              href={formatSearchLink(modelValue)}
              onClick={() => sendGtagEvent("click", "popular_model", modelValue)}
              className={`${styles.modelLink} ${isActive ? styles.active : ""}`}
            >
              <MantineText span>{formatDisplayLabel(modelValue)}</MantineText>
            </Link>
          );
        })}
      </MantineBox>
    </MantineBox>
  );
};

export default PopularModels;
